<template>
  <div v-if="authStore.isAuthenticated" class="pa-0">
    <v-container fluid>
      <v-row justify="center" class="mb-6">
        <v-col cols="12" md="12">
          <v-card elevation="10">
            <v-card-title class="bg-primary white--text d-flex align-center">
              ตรวจสอบสถานะการสมัครศิษย์เก่า
            </v-card-title>
            <v-card-text class="pa-4 pa-sm-6 rounded"></v-card-text>
            <v-data-table
              v-if="alumni"
              :headers="headers"
              :items="alumni"
              :loading="loading"
              v-model:options="tableOptions"
              :server-items-length="alumni.length"
              style="font-size: 16px"
            >
              <template v-slot:item.drive="{ item }">
                <a :href="item.drive" target="_blank">
                  <v-btn color="green" text="go to" variant="elevated">
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </a>
              </template>

              <template v-slot:item.folder="{ item }">
                <v-btn
                  rounded="lg"
                  text="Approve"
                  variant="elevated"
                  color="primary"
                  @click="
                    approveStudent(
                      item.rowNumber,
                      item.id,
                      item.LineId,
                      item.phone,
                      item.email,
                    )
                  "
                ></v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, reactive } from "vue";
import { useAuthStore } from "@/stores/auth";
import axios from "axios";

const authStore = useAuthStore();
const alumni = ref([]);
const loading = ref(false);
const totalItems = ref(0);
const TOKEN = authStore.getBackendJwt();
const headers = ref([
  { title: "row", key: "rowNumber", sortable: true, fixed: "start" },
  { title: "ID", key: "id", sortable: false, fixed: "start" },
  {
    title: "Name",
    key: "fullName",
    sortable: false,
  },
  {
    title: "Status",
    key: "status",
    sortable: false,
    align: "start",
  },
  {
    title: "folder",
    key: "drive",
    sortable: false,
    fixed: "end",
  },
  {
    title: "Action",
    key: "folder",
    sortable: false,
    width: "50px",
    fixed: "end",
  },
]);
const tableOptions = ref({
  page: 1,
  itemsPerPage: 10,
  sortBy: [],
  sortDesc: [],
  multiSort: false,
  //   search: "",
  //   searchType: "fullName"
});

const fetchAlumni = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`/api/admin_check`, {
      //   params: {
      //     search: searchReq.value, // <-- Use the new centralized search property
      //     searchType: searchOption.value,
      //   },
      //   headers: {
      //     Authorization: `Bearer ${TOKEN}`,
      //     "Content-Type": "application/json",
      //   },

      validateStatus: function (status) {
        return (
          (status >= 200 && status < 300) ||
          status === 400 ||
          status === 403 ||
          status === 401
        );
      },
    });

    if (response.status === 200) {
      const data = response.data;
      alumni.value = data.studentNum;
      totalItems.value = data.totalFound;
      console.log(`found student =`, alumni.value);
    } else if (response.status === 500) {
      await proxy.$swal({
        title: "Error!",
        text: response.data?.message || "Invalid Operation",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        customClass: {
          container: "my-swal-container", // Apply a custom class to the main SweetAlert container
        },
      });
    }

    // totalItems.value = data.totalItems;
  } catch (error) {
    console.error("Error fetching students:", error);

    alumni.value = [];
  } finally {
    loading.value = false;
  }
};

const approveStudent = async (rowNumber, num, LineId, phone, email) => {
  console.log("request on roll", rowNumber, num, LineId, phone, email);
  try {
    const response = await axios.post(
      `/api/approve_student`,
      // Argument 2: The Data (Body)
      {
        row: rowNumber,
        studentNum: num,
        LineId: LineId,
        PhoneNum: phone,
        ContactEmail: email,
      },
      // Argument 3: The Config (Headers, validateStatus, etc.)
      {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        validateStatus: function (status) {
          return (
            (status >= 200 && status < 300) ||
            status === 400 ||
            status === 403 ||
            status === 401
          );
        },
      },
    );

    if (response.status === 200) {
      alert("Student Approved");
      await fetchAlumni();
    }
  } catch (err) {
    console.error("ERROR:", err);
  }
};

onMounted(() => {
  fetchAlumni();
});
</script>
